import { FilterPill } from 'types/srpFilters';
import { FilterPillFn } from './useCreateFilterPills';

type MultiMakeModelFilter = { make?: string; model?: string; trims?: string[] };

export default function useMultiMakeModelPillsCreator(): FilterPillFn {
  return (makeModelFilters: MultiMakeModelFilter[]): FilterPill[] => {
    function generateLabel(makeModelFilter: { make?: string; model?: string }): string {
      return `${makeModelFilter.make} ${makeModelFilter.model || ''}`.trim();
    }

    return makeModelFilters
      .filter((f) => f.make)
      .flatMap((makeModelFilter) => {
        const pills: FilterPill[] = [];

        // Create the make/model pill
        pills.push({
          name: generateLabel(makeModelFilter),
          label: generateLabel(makeModelFilter),
          resetState: {
            MultiMakeModel: {
              make: makeModelFilter.make,
              model: makeModelFilter.model,
              trims: [],
            },
          },
        });

        // Create individual trim pills if trims exist
        if (makeModelFilter.trims && makeModelFilter.trims.length > 0) {
          makeModelFilter.trims.forEach((trim: string) => {
            pills.push({
              name: trim,
              label: trim,
              resetState: {
                MultiMakeModel: {
                  make: makeModelFilter.make,
                  model: makeModelFilter.model,
                  trims: makeModelFilter.trims?.filter((t) => t !== trim) || [],
                },
              },
            });
          });
        }

        return pills;
      });
  };
}
